// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .stamp-preview canvas[data-v-a656a8fc] {\n  border: 1px dashed #ddd;\n}\n.canvas-scroll[data-v-a656a8fc] {\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
